import styled from 'styled-components';

export const StyledPagination = styled.div`
  margin-top: 20px;
  .pagination {

    .page-item {
      display: inline;
      margin-right: 5px;
      
      &.active .page-link {
        background: linear-gradient(120deg, #1a1c28 60%, #0f1219 100%);
        color: #fff;
        border: 1px solid #5fa8e6;
        box-shadow: 0 0 3px 1px #00eaff;
      }
      
      .page-link {
        color: #fff;
        background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
        border: 1px solid #5fa8e6;
        padding: 8px 12px;
        cursor: pointer;
        box-shadow: 0 0 3px 0.5px #00eaff;
        transition: all 0.3s ease;
        
        &:hover {
          background: linear-gradient(120deg, #1a1c28 60%, #0f1219 100%);
          box-shadow: 0 0 4px 1px #00eaff;
          transform: translateY(-2px);
        }
      }
    }
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  text-align: left;
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  color: #fff;
  table-layout: auto; 
  overflow-x: auto;
  border: 2px solid #5fa8e6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 4px 1px #00eaff;

  @media (max-width: 768px) {
    .btn {
      padding: 0.25rem 0.5rem; 
      font-size: 0.875rem;
      .fa { 
        display: none;
      }
    }
  }

  th {
    background: linear-gradient(120deg, #1a1c28 60%, #0f1219 100%);
    color: #fff;
    padding: 12px 15px;
    border-bottom: 1px solid #5fa8e6;
    font-weight: 600;
  }

  td {
    padding: 10px 15px;
    border-bottom: 1px solid rgba(95, 168, 230, 0.3);
  }

  tr:nth-child(even) {
    background-color: rgba(0, 234, 255, 0.02);
  }

  tr:hover {
    background-color: rgba(95, 168, 230, 0.1);
    cursor: pointer;
    box-shadow: inset 0 0 8px rgba(0, 234, 255, 0.1);
    transition: all 0.3s ease;
  }

  th.actions, td.actions {
    text-align: right;
  }
`;

export const StyledNoDataFound = styled.div`
  padding: 10px;
  text-align: center;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  color: #fff;
  border-top: 1px solid rgba(95, 168, 230, 0.3);
`;